var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"lesson"},[_c('ActivityThumbnails',{attrs:{"title":_vm.lessonTitle,"lesson-data":_vm.lessonData},on:{"on-prev":function($event){return _vm.$emit('on-prev')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }